var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('span',{},[_c('el-image',{staticClass:"image",attrs:{"src":_vm.src},on:{"click":_vm.preview}}),(_vm.preview_visible)?_c('components-preview',{attrs:{"images":_vm.preview_image},on:{"closeViewer":_vm.cancelPreview}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }